import type { LucideIcon } from 'lucide-react';
interface KpiCardProps {
    title: string;
    value: string | number;
    subtitle?: string;
    delta?: number | null;
    tone?: 'primary' | 'success' | 'warning' | 'info' | 'secondary';
    icon?: LucideIcon;
}

export default function KpiCard({ title, value, subtitle, delta, icon: Icon }: KpiCardProps) {
    const deltaValue = typeof delta === 'number' && Number.isFinite(delta) ? delta : null;
    const deltaClass = deltaValue === null || deltaValue === 0
        ? 'text-base-content/60' : deltaValue > 0 ? 'text-success' : 'text-error';

    return (
        <div className="sf-dashboard-metric">
            <div className="sf-dashboard-metric-label">
                <span>{title}</span>
                {Icon && <Icon aria-hidden="true" />}
            </div>
            <div className="sf-dashboard-metric-value">{value}</div>
            {subtitle && <p className="sf-dashboard-metric-note">{subtitle}</p>}
            {delta !== undefined && (
                <p className={`sf-dashboard-metric-note ${deltaClass}`}>
                    {deltaValue === null ? 'Sem comparativo disponível' : (
                        <>
                            <span className="font-medium">{deltaValue > 0 ? '+' : ''}{deltaValue.toFixed(1)}%</span>
                            <span className="text-base-content/60"> vs. período anterior</span>
                        </>
                    )}
                </p>
            )}
        </div>
    );
}
